import React from 'react';
import { serviceRegions } from '../data/mockData';
import { MapPin } from 'lucide-react';

export const NSWCoverageSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Supporting Project Delivery Across NSW

          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            Regional experience delivering projects throughout New South Wales
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="p-8 bg-blue-50 rounded-lg border-l-4 border-blue-900">
            <p className="text-slate-700 text-lg leading-relaxed">
              RHE Project Consulting has successfully delivered infrastructure projects across NSW, 
              with particular strength in the Hunter, Central Coast, and Newcastle regions. Our regional 
              knowledge and established relationships with local councils and government agencies enable 
              effective project delivery.
            </p>
          </div>
        </div>
      </div>
    </section>);

};